module.exports = __webpack_public_path__ + "img/barbecue.aba837c6.svg";